import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import 'rxjs';
import { Observable } from 'rxjs';

import { Staff } from '../Models/index';

@Injectable()
export class StaffService {

  private headers = new Headers({'Content-Type': 'application/json'});
  private staffsUrl = 'api/staffs';  // URL to web api

  staff = null;

  constructor(private http: Http) {}

  // Get staff api by pin number
  getStaffbyPin(pin: string){
    let school = Number(localStorage.getItem('school'));
    const url = `${this.staffsUrl}/${school}/${pin}`;
    let data = this.http.get(url)
      .map(data => data.json());
    // Use a variable to store the data.
    this.staff = data;
    return data;
  }
  // Return cache staff
  getStaff() {
    return this.staff;
  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/staff.service.ts